import { Globals } from "@/app/vars/Globals";

export class UStorage {
  private static readonly USERS_DIR = "users";
  private static readonly INSOLE_MODELS_DIR = "insole-models";
  private static readonly PREVIEWS_DIR = "previews";

  public static fileExtension(fileName: string): string {
    const dot = fileName.lastIndexOf(".");
    return dot >= 0 ? fileName.slice(dot).toLowerCase() : "";
  }

  public static insoleModelPath(isPublic: boolean, userUuid: string): string {
    const fileName = `${crypto.randomUUID()}${Globals.INSOLE_MODEL_FILE_EXTENSION}`;

    if (isPublic) {
      return `${UStorage.INSOLE_MODELS_DIR}/${fileName}`;
    }

    return `${UStorage.USERS_DIR}/${userUuid}/${UStorage.INSOLE_MODELS_DIR}/${fileName}`;
  }

  public static insoleModelWorkingPath(isPublic: boolean, userUuid: string): string {
    const fileName = `${crypto.randomUUID()}${Globals.INSOLE_MODEL_FILE_EXTENSION}`;

    if (isPublic) {
      return `${UStorage.INSOLE_MODELS_DIR}/working/${fileName}`;
    }

    return `${UStorage.USERS_DIR}/${userUuid}/${UStorage.INSOLE_MODELS_DIR}/working/${fileName}`;
  }

  public static insoleModelPreviewPath(
    isPublic: boolean,
    userUuid: string,
    extension: string,
  ): string {
    const fileName = `${crypto.randomUUID()}${extension}`;

    if (isPublic) {
      return `${UStorage.INSOLE_MODELS_DIR}/${UStorage.PREVIEWS_DIR}/${fileName}`;
    }

    return `${UStorage.USERS_DIR}/${userUuid}/${UStorage.INSOLE_MODELS_DIR}/${UStorage.PREVIEWS_DIR}/${fileName}`;
  }
}
